import { Set } from '@gonfalon/immutable-shim/immutableShim';
import { isArray } from 'lodash';

import type { FilterValue } from '#components/ui/multipleFilters/types';
import { FilterKind } from '#components/ui/multipleFilters/types';
import type {
  BackendQueryParamName,
  FlagFilterInterface,
  QueryParamName,
} from '#utils/flagFilters/flagFilterInterface';
import { FilterOperator, FlagListBackendQueryParam, FlagListQueryParam } from '#utils/flagFilters/types';

const TAGS = 'tags';
const TAGS_DISPLAY_NAME = 'Tag(s)';

export class TagsFilter implements FlagFilterInterface<string[]> {
  name: string;
  value: Set<string>;
  kind: FilterKind;
  queryParamName: QueryParamName;
  backendQueryParamName: BackendQueryParamName;
  operators: string[];
  defaultValue: string;

  constructor(value?: Set<string>) {
    this.name = TAGS_DISPLAY_NAME;
    this.value = value || Set();
    this.kind = FilterKind.TAGS;
    this.queryParamName = FlagListQueryParam.TAG;
    this.backendQueryParamName = FlagListBackendQueryParam.TAGS;
    this.operators = [FilterOperator.ARE_ALL_OF];
    this.defaultValue = '';
  }

  getFilterValueDisplayName(value?: FilterValue) {
    if (isArray(value)) {
      return value.join(', ');
    }

    return '';
  }

  getDisplayName = () => this.name;

  getOptions() {
    // Tags has it's own container to fetch value
    return [];
  }

  isEnabled = () => true;

  isEmpty = () => this.value.isEmpty();

  toQuery = () => this.value.toList().sort().toJS() as string[];

  isInvalidFilter = () => false;

  clearFilter = () => (this.value = Set());

  toBackendQuery() {
    if (this.isEmpty()) {
      return '';
    }

    return `${TAGS}:${this.value.toArray().join('+')}`;
  }

  parseFilterParam(queryParts: string[]) {
    if (queryParts.length !== 2) {
      return [];
    }
    const [, value] = queryParts;
    return value.split('+');
  }

  getFilterData() {
    // Tags has it's own container to fetch option values
    return {
      operators: this.operators,
      options: [],
      defaultValue: this.defaultValue,
    };
  }
}
